export const LogoMark = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true">
    <rect x="2" y="2" width="44" height="44" rx="13" fill="#087F72" />
    <ellipse cx="15" cy="19" rx="3.6" ry="4.6" fill="#E6F4EF" />
    <ellipse cx="24" cy="14.5" rx="3.6" ry="4.6" fill="#E6F4EF" />
    <ellipse cx="33" cy="19" rx="3.6" ry="4.6" fill="#E6F4EF" />
    <path d="M24 23c-6 0-10 6.5-10 10.2 0 3 2.4 4.3 5 4.3 2 0 3.2-.9 5-.9s3 .9 5 .9c2.6 0 5-1.3 5-4.3C34 29.5 30 23 24 23z" fill="#E6F4EF" />
    <g transform="translate(29 27) rotate(-20)">
      <path d="M0 4.5 4.5 0H15v9H4.5z" fill="#F0A94C" stroke="#087F72" strokeWidth="1.4" strokeLinejoin="round" />
      <circle cx="5.2" cy="4.5" r="1.3" fill="#087F72" />
    </g>
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="inline-flex items-center gap-2.5" data-testid="vetpris-logo">
    <LogoMark />
    <span className={`font-heading text-[1.4rem] font-extrabold tracking-tight ${light ? "text-white" : "text-[#153C3A]"}`}>
      Vet<span className={light ? "text-[#F0A94C]" : "text-[#087F72]"}>Pris</span>
    </span>
  </span>
);
